import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { EmptyStateComponent } from '@principle-theorem/ng-principle-shared';
import {
  InputSearchFilter,
  NgDialogModule,
  toSearchStream,
  TypedFormControl,
} from '@principle-theorem/ng-shared';
import {
  CustomReportTemplate,
  getReportBuilderTemplates,
  ICustomReportTemplate,
  REPORT_BUILDER_DATA_SOURCES,
} from '@principle-theorem/reporting';
import { sortBy } from 'lodash';
import { of } from 'rxjs';
import { SelectReportTemplateCardComponent } from './select-report-template-card/select-report-template-card.component';

export interface ISelectReportTemplateDialogResponse {
  template: ICustomReportTemplate;
}

@Component({
  selector: 'pr-select-report-template-dialog',
  imports: [
    EmptyStateComponent,
    NgDialogModule,
    SelectReportTemplateCardComponent,
  ],
  templateUrl: './select-report-template-dialog.component.html',
  styleUrl: './select-report-template-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectReportTemplateDialogComponent {
  private _dialogRef =
    inject<
      MatDialogRef<
        SelectReportTemplateDialogComponent,
        ISelectReportTemplateDialogResponse
      >
    >(MatDialogRef);
  searchCtrl = new TypedFormControl<string>('');
  filteredTemplates: Signal<ICustomReportTemplate[]>;

  constructor() {
    const templates = this._getTemplates();
    const searchFilter = new InputSearchFilter<ICustomReportTemplate>(
      of(templates),
      toSearchStream(this.searchCtrl),
      ['name', 'description', (template) => template.tags?.join(' ') ?? '']
    );
    this.filteredTemplates = toSignal(searchFilter.results$, {
      initialValue: [],
    });
  }

  select(template: ICustomReportTemplate): void {
    this._dialogRef.close({ template });
  }

  private _getTemplates(): ICustomReportTemplate[] {
    const reportTemplates = getReportBuilderTemplates();
    const basicTemplates = REPORT_BUILDER_DATA_SOURCES.filter(
      (dataSource) => !dataSource.isRetired
    ).map((dataSource) =>
      CustomReportTemplate.basicDataSourceTemplate(dataSource)
    );
    return [
      ...sortBy(reportTemplates, 'name'),
      ...sortBy(basicTemplates, 'name'),
    ];
  }
}
